<template>
  <Layout>
    <div class="container">
      <div class="row">
        <div class="col-md-12 mt-3">
          <div class="card card-widget widget-user">
            <!-- Add the bg color to the header using any of the bg-* classes -->
            <div
              class="widget-user-header text-white"
              style="background-image:url('/img/cover-ea.jpg')"
            >
              <h3 class="widget-user-username text-right">Expert Advisors</h3>
            </div>
            <div class="widget-user-image">
              <img class="img-circle" src="/img/EA.png" alt="User Avatar" />
            </div>
            <div class="card-footer">
              <div class="row">
                <div class="col-sm-4 border-right">
                  <div class="description-block">
                    <h5 class="description-header"></h5>
                    <span class="description-text"></span>
                  </div>
                  <!-- /.description-block -->
                </div>
                <!-- /.col -->
                <div class="col-sm-4 border-right">
                  <div class="description-block">
                    <h5 class="description-header">EA Copy Trade Fxhanuman_Sumo</h5>
                    <span class="description-text"></span>
                  </div>
                  <!-- /.description-block -->
                </div>
              </div>
              <!-- /.row -->
            </div>
          </div>
        </div>

        <!-- Card EA Detail  -->

        <div class="col-md-12">
          <div class="card">
            <div class="card-header bg-light">
              <h4>ข้อมูล</h4>
            </div>
            <div class="row">
              <div class="md-form col-md-1 mt-3 ml-3">
                <label class="header-card">ชื่อ :</label>
              </div>
              <div class="md-form col-md-10 mt-3 ml-3">
                <label>EA Copy Trade Fxhanuman_Sumo</label>
              </div>
            </div>

            <div class="row">
              <div class="md-form col-md-1 mt-1 ml-3">
                <label class="header-card">ชนิด :</label>
              </div>
              <div class="md-form col-md-2 mt-1 ml-3">
                <label>EA</label>
              </div>

              <div class="md-form col-md-2 mt-1 ml-3">
                <label class="header-card">รูปแบบ :</label>
              </div>
              <div class="md-form col-md-4 mt-1 ml-3">
                <label>Copy Trade</label>
              </div>
            </div>

            <div class="row">
              <div class="md-form col-md-1 mt-1 ml-3">
                <label class="header-card">ผู้พัฒนา :</label>
              </div>
              <div class="md-form col-md-2 mt-1 ml-3">
                <label>Fxhanuman Team</label>
              </div>

              <div class="md-form col-md-2 mt-1 ml-3">
                <label class="header-card">สนับสนุน :</label>
              </div>
              <div class="md-form col-md-4 mt-1 ml-3">
                <label>Serial Keys</label>
              </div>
            </div>

            <div class="row">
              <div class="md-form col-md-1 mt-1 ml-3">
                <label class="header-card">วันที่สร้าง :</label>
              </div>
              <div class="md-form col-md-2 mt-1 ml-3">
                <label>10/11/2019</label>
              </div>

              <div class="md-form col-md-2 mt-1 ml-3">
                <label class="header-card">แก้ไขล่าสุด :</label>
              </div>
              <div class="md-form col-md-4 mt-1 ml-3">
                <label>15/11/2019</label>
              </div>
            </div>

            <div class="row">
              <div class="md-form col-md-6 m-3">
                <a
                  href="#"
                  data-target="#Download_Agreement_Serial"
                  data-toggle="modal"
                  type="button"
                  class="btn btn-success btn-icon-split col-md-6"
                >
                  <span class="icon text-white-50 mr-auto">
                    <i class="fas fa-cloud-download-alt"></i>
                  </span>

                  <span class="text mr-auto"> Download</span>
                  <span class="text mr-auto"> v1-53</span>
                </a>
                <!--  -->
              </div>
            </div>
            <!-- End Card EA Detail -->
          </div>
          <!-- .card-block .tab-content -->
        </div>

        <!-- Card EA Content  -->
        <div class="col-md-12">
          <div class="card">
            <div class="card-header bg-light">
              <h4>รายละเอียด</h4>
            </div>

            <div class="container">
              <div class="md-form col-md-12 mt-1">
                <h2>
                  <strong>EA Copy Trade Fxhanuman Sumo</strong>
                </h2>

                <p>
                  <strong>เป็น EA Copy Trade ที่มีความสามารถในด้านต่างๆ ดังนี้</strong>
                </p>

                <ol>
                  <li>สามารถ Copy การแบ่งปิดออเดอร์ได้ (Partial Close)</li>
                  <li>
                    โหมดการทำงานแบบสองทาง คือ สามารถทำ
                    <span style="color:#d35400">Copy Trade</span>
                    <ol>
                      <li>แบบปกติก็คือ Master 1 way ตัวเดียวมี Slave กี่ตัวก็ได้</li>
                      <li>
                        แบบ Master 2 way&nbsp; ซึ่งเหมาะสำหรับการทำ
                        <a
                          href="https://fxhanuman.com/web/eafx/Beta/Product.php?id=EA0004"
                        >Carry trade</a> ที่หากออเดอร์ฝั่งใดมีการเปลี่ยนแปลง จะทำการ Sync Order ของทั้งสองให้เท่ากัน
                      </li>
                    </ol>
                  </li>
                  <li>
                    สามารถ
                    <span style="color:#d35400">Copy Trade</span> ระหว่าง VPS, Server, Computer ได้ แม้อยู่คนล่ะทวีปกัน เหมาะสำหรับวงเทรดที่มีสลาฟจำนวมากและมาสเตอร์ 1 ตัว
                  </li>
                  <li>
                    สามารถ ReverseOrderType จากออเดอร์ Master เช่น Master เปิด
                    <span
                      style="color:#2980b9"
                    >Buy</span>--&gt; Slave เปิด
                    <span style="color:#e74c3c">Sell</span>
                  </li>
                  <li>
                    สามารถ
                    <span style="color:#d35400">Copy Trade</span>
                    <span style="color:#e67e22"></span>โบรกเกอร์ที่มีชื่อ Symbol แตกต่างกัน เช่น EURUSDpro,EURUSD#
                  </li>
                  <li>ปรับเรทการตามล็อตจากมาสเตอร์ได้ เป็นจำนวนตัวเลขที่ต้องการของ สลาฟ</li>
                </ol>

                <p>
                  <strong>เงื่อนไขการใช้งาน EA-CopyTrade-Fxhanuman &amp; Sumo</strong>
                </p>

                <ol>
                  <li>บัญชี Demo สามารถใช้ฟรี (ต้องการใช้งานกรุณติดต่อ Support)</li>
                  <li>EA จะมี SerialNumber ของแต่ล่ะ มาสเตอร์ ที่ใช้งานจะไม่เหมือนกัน เพื่อป้องกันการใช้งาน ฟังชั่น และเวลา ที่กำหนดไว้</li>
                  <li>ในการใช้งาน EA จะต้องใช้ MT4 ของผู้ซื้อล๊อกอิน 1 MT4 จะเป็น Master ที่ใช้การตั้งค่าของ SerialNumber</li>
                </ol>

                <ul>
                  <li>
                    <span
                      style="color:#d35400"
                    >ค่าบริการ 500บาท / 1 Master /&nbsp; 10 Slave ID ( ค่าบริการ จะคิดตามจำนวนสลาฟ )</span>
                  </li>
                  <li>ตัวอย่าง SerialNumber ที่กำหนดวันหมดอายุ และลักษณะการใช้าน</li>
                  <li>F3E479570DDEB54D7853EF574EA62F8BE55U_2019.11.17_637098_._._291_FXH-CP</li>
                </ul>

                <p>&nbsp;</p>

                <p>
                  หากต้องการใช้งาน กรุณาติดต่อ
                  <strong>Line ID: @fxhanuman</strong> เพื่อทำการชำระค่าบริการ
                </p>

                <p>และเมื่อชำระเงินเรียบร้อยทาง Fxhanuman จะส่ง SerialNumber ให้ท่านติดตั้งและเปิดใช้งานได้ทันที</p>

                <p>
                  <a
                    href="http://fxhanuman.com/web/eafx/upload_Images/images/Untitled-2.png"
                    target="_blank"
                  >
                    <img
                      alt
                      src="http://fxhanuman.com/web/eafx/upload_Images/images/Untitled-2.png"
                      style="height:100%; width:100%"
                    />
                  </a>
                </p>

                <p>
                  สั่งซื้อ Serial เพื่อใช้งานกับบัญชีจริงได้ที่ Line ID:
                  <span
                    style="color:#27ae60"
                  >@fxhanuman</span>
                </p>

                <p>
                  <strong>วิธีการตั้งค่า EA-CopyTrade-Fxhanuman &amp; Sumo</strong>
                </p>

                <p>
                  <a
                    href="http://fxhanuman.com/web/eafx/upload_Images/images/Untitled-1.png"
                    target="_blank"
                  >
                    <img
                      alt
                      src="http://fxhanuman.com/web/eafx/upload_Images/images/Untitled-1.png"
                      style="height:100%; width:100%"
                    />
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
        <!-- End Card EA Content  -->
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "@/components/Layout";
export default {
  name: "productdetail",
  components: {
    Layout
  }
};
</script>

<style scoped>
.widget-user-header {
  background-position: 50%;
}
.widget-user .widget-user-header {
  height: 150px;
}
.widget-user .widget-user-image {
  top: 100px;
}

.header-card {
  color: #ffc107;
}
</style>